module.exports = __webpack_public_path__ + "img/aafda_logo.3cd0059b.png";